import { ArrowRight, EyeOff, Eye } from "lucide-react";
import { Reveal } from "../Reveal";
import { scrollToId } from "../../lib/scroll";

export const FunnelProblem = () => (
    <section id="problem" className="relative bg-white text-noir py-24 sm:py-32 overflow-hidden" data-testid="funnel-problem">
        <div className="mx-auto max-w-[1100px] px-4 sm:px-6 text-center">
            <Reveal>
                <p className="eyebrow">THE VISIBILITY PROBLEM</p>
            </Reveal>
            <Reveal delay={0.08}>
                <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.02] tracking-tight">
                    YOUR CUSTOMERS ARE OUT THERE.
                    <span className="block text-[#A6A6A6]">CAN THEY SEE YOU?</span>
                </h2>
            </Reveal>
            <Reveal delay={0.16}>
                <p className="mx-auto mt-7 max-w-2xl text-sm sm:text-base leading-relaxed text-zinc-600">
                    Every day, your customers drive, shop, commute, work, and travel past premium digital screens.
                    Businesses that show up on those screens get seen — and get chosen. WealthHaus Media helps you
                    reach customers where they live, shop, work, travel, commute, and spend their time, with
                    professional digital advertising solutions designed to increase visibility and put your brand
                    in front of more eyes.
                </p>
            </Reveal>
            <Reveal delay={0.24}>
                <div className="mx-auto mt-10 grid sm:grid-cols-2 gap-4 max-w-2xl text-left">
                    <div className="rounded-2xl border border-zinc-200 bg-zinc-50 p-6">
                        <EyeOff size={22} className="text-zinc-400" />
                        <p className="mt-3 font-alt text-sm font-bold tracking-wide text-noir">WITHOUT VISIBILITY</p>
                        <p className="mt-2 text-[13px] leading-relaxed text-zinc-500">Your brand competes for attention it never wins — unseen in the places your customers already look.</p>
                    </div>
                    <div className="rounded-2xl border-2 border-hotpink bg-noir p-6 shadow-[0_0_40px_rgba(255,255,255,0.2)]">
                        <Eye size={22} className="text-hotpink" />
                        <p className="mt-3 font-alt text-sm font-bold tracking-wide text-white">WITH DIGITAL BILLBOARDS</p>
                        <p className="mt-2 text-[13px] leading-relaxed text-zinc-300">Your brand appears on digital screens across the places your audience lives, shops, works, and travels.</p>
                    </div>
                </div>
            </Reveal>
            <Reveal delay={0.3}>
                <button className="btn-glossy-pink mt-10" onClick={() => scrollToId("#quote")} data-testid="problem-quote-button">
                    GET MY BILLBOARD QUOTE <ArrowRight size={16} />
                </button>
            </Reveal>
        </div>
    </section>
);
